<div class="projects mb-4">
    <div class="card">
            <div class="card-header header-background">
                  <div class="row">
                      <div class="col-sm-3">
                          <h2>Autoevaluación</h2>
                      </div>
                  </div>
            </div>
    

            <div>
                <ul class="nav nav-tabs">
                    <li class="nav-item">
                        <a class="nav-link active" data-bs-toggle="tab" href="#resumen">Resumen</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" data-bs-toggle="tab" href="#detalle" (click)="showDetalle = true">Detalle</a>
                    </li>
                </ul>
                <div id="myTabContent" class="tab-content">

                    <div class="tab-pane fade show active" id="resumen">
                        <div style="padding: 20px 50px;">
                            <div class="row">
                                <app-autoevaluacion-resumen></app-autoevaluacion-resumen>
                            </div>
                        </div>
                    </div>

                    <div class="tab-pane fade show" id="detalle">
                        <div style="padding: 20px 50px;">
                            <div class="row">
                                <app-autoevaluacion-seguimiento *ngIf="showDetalle"></app-autoevaluacion-seguimiento>  
                            </div>
                        </div>
                    </div>


                </div>

            </div>
    </div>
  </div>




<!-- <mat-drawer-content style="margin-left: 1px;">
    <app-autoevaluacion-inicio *ngIf="menuMostrar==='inicio'"></app-autoevaluacion-inicio>  
    <app-autoevaluacion-resumen *ngIf="menuMostrar==='resumen'"></app-autoevaluacion-resumen>
    <app-autoevaluacion-seguimiento *ngIf="menuMostrar==='seguimiento'"></app-autoevaluacion-seguimiento>  
    <app-diario-seguimiento *ngIf="menuMostrar==='diario-seguimiento'"></app-diario-seguimiento>  
    <app-verificacion-seguimiento *ngIf="menuMostrar==='verificacion-seguimiento'"></app-verificacion-seguimiento>  
</mat-drawer-content> -->